import publicRules from './rules'

let sTrigger = 'xx';

function bindRules4Flow(vm, act) {
    let thisRules = {};

    // 流程必填域
    if (vm.process && vm.process.notnullitems) {
        let sNotnullitems = vm.process.notnullitems;
        for (let currNotnullitem of sNotnullitems.split(';')) {
            if (!currNotnullitem) {
                continue;
            }

            let rules = new Array();
            let aNotnullitem = currNotnullitem.split('|');
            let tipmsg = vm.$t('flow_process.notnulltip');
            let message = '';
            let sInvokeMethod = '';
            if ('submit' == act) {
                message = aNotnullitem[1] + "," + tipmsg;
                sInvokeMethod = 'validateRequired';
            } else {
                sInvokeMethod = 'validatePass';
            }
            rules.push({
                required: true,
                validator: (rule, value, callback) => {
                    publicRules.FormValidate.Form()[sInvokeMethod](rule, value, callback, message, vm.formTipArray);
                },
                trigger: sTrigger
            });

            thisRules[aNotnullitem[0].toLowerCase()] = rules;
        }
    }

    // cview配置
    if (vm.formValidateInfo && vm.formValidateInfo.elementLabels) {
        for (let currElementLabel of vm.formValidateInfo.elementLabels) {
            let sId = currElementLabel.id;
            if (!sId) {
                continue;
            }
            sId = sId.toLowerCase();

            let rules = new Array();
            let oCurrRule = thisRules[sId];
            if (oCurrRule) {
                rules = oCurrRule;
            }

            // 校验规则
            let oValidate = vm.formValidateInfo.validateJson[sId];
            if (oValidate) {
                for (let sMethod in oValidate) {
                    if (!sMethod) {
                        continue;
                    }

                    rules.push({
                        elementLabelInfo: currElementLabel,
                        methodInfo: oValidate[sMethod],
                        validator: (rule, value, callback) => {
                            publicRules.FormValidate.Form()[sMethod](rule, value, callback, vm);
                        },
                        trigger: sTrigger
                    });
                }
            }

            if (!oCurrRule) {
                thisRules[sId] = rules;
            }
        }
    }

    vm.rules = thisRules;
}
function bindRules4NotFlow(vm, act){
    let thisRules = {};

    // cview配置
    if (vm.formValidateInfo && vm.formValidateInfo.elementLabels) {
        for (let currElementLabel of vm.formValidateInfo.elementLabels) {

            let sId = currElementLabel.id;
            if (!sId) {
                continue;
            }
            sId = sId.toLowerCase();

            let rules = new Array();
            let oCurrRule = thisRules[sId];
            if (oCurrRule) {
                rules = oCurrRule;
            }
            let oRequired = vm.formValidateInfo.requiredJson[sId];
            let bIsRequired = oRequired ? true : false;
            let sLabel = currElementLabel.label;
            let sInvokeMethod = '';
            if (bIsRequired) {
                if ('submit' == act) {
                    sInvokeMethod = 'validateRequired';
                } else {
                    sInvokeMethod = 'validatePass';
                }
                // cview必填
                let tipmsg = vm.$t('flow_process.notnulltip');
                let message = sLabel + "," + tipmsg;
                rules.push({
                    required: true,
                    validator: (rule, value, callback) => {
                        publicRules.FormValidate.Form()[sInvokeMethod](rule, value, callback, message, vm.formTipArray);
                    },
                    trigger: sTrigger
                });
            }

            // 校验规则
            let oValidate = vm.formValidateInfo.validateJson[sId];
            if (oValidate) {
                for (let sMethod in oValidate) {
                    if (!sMethod) {
                        continue;
                    }

                    rules.push({
                        elementLabelInfo: currElementLabel,
                        methodInfo: oValidate[sMethod],
                        validator: (rule, value, callback) => {
                            publicRules.FormValidate.Form()[sMethod](rule, value, callback, vm);
                        },
                        trigger: sTrigger
                    });
                }
            }

            if (!oCurrRule) {
                thisRules[sId] = rules;
            }
        }
    }

    vm.rules = thisRules;
}
/**
 * 校验表单
 * @param {*} vm
 * @param {*} formName
 */
function validateForm(vm, formName) {
    if (vm.aFormValidateTip) {
        for (let oFormValidateTip of vm.aFormValidateTip) {
            oFormValidateTip.close();
        }
    }

    let isValidateSucc = false;
    vm.$refs[formName].validate((valid) => {
        isValidateSucc = valid;
        if (valid) {
            vm.tipRight(vm.$t('formValidate.success'),vm.$t('formValidate.savesuccess'),'success');
        } else {
            let sTipTitle = vm.$t('formValidate.tipTitle');
            let oFormValidateTip = vm.formErrorTip2(sTipTitle, vm.formTipArray);
            vm.aFormValidateTip.push(oFormValidateTip);
            vm.formTipArray.length = 0;
        }
    });

    return isValidateSucc;
}

export default {
    bindRules4Flow,
    bindRules4NotFlow,
    pushFormValidateTip(vm, oFormValidateTip) {
        if (vm.aFormValidateTip) {
            vm.aFormValidateTip.push(oFormValidateTip);
        }
    },
    clearFormValidateTip(vm) {
        if (vm.aFormValidateTip) {
            for (let oFormValidateTip of vm.aFormValidateTip) {
                oFormValidateTip.close();
            }
        }
    },
    initViewInfo4NotFlow2(vm, respFormValidateInfo) {
        // 初始化表单验证信息（无流程）
        vm.formValidateInfo = respFormValidateInfo;

        let thisRules = {};
        if (vm.formValidateInfo && vm.formValidateInfo.elementLabels) {
            for (let currElementLabel of vm.formValidateInfo.elementLabels) {
                let sId = currElementLabel.id;
                if (!sId) {
                    continue;
                }
                sId = sId.toLowerCase();

                let rules = new Array();
                let oRequired = vm.formValidateInfo.requiredJson[sId];
                let bIsRequired = oRequired ? true : false;
                let sLabel = currElementLabel.label;

                if (bIsRequired) {
                    let sInvokeMethod = 'validatePass';
                    // cview必填
                    let tipmsg = vm.$t('flow_process.notnulltip');
                    let message = sLabel + "," + tipmsg;
                    rules.push({
                        required: true,
                        validator: (rule, value, callback) => {
                            publicRules.FormValidate.Form()[sInvokeMethod](rule, value, callback, message, vm.formTipArray);
                        },
                        trigger: sTrigger
                    });
                }

                let oValidate = vm.formValidateInfo.validateJson[sId];
                if (oValidate) {
                    // cview规则
                    for (let sMethod in oValidate) {
                        if (!sMethod) {
                            continue;
                        }

                        rules.push({
                            elementLabelInfo: currElementLabel,
                            methodInfo: oValidate[sMethod],
                            validator: (rule, value, callback) => {
                                publicRules.FormValidate.Form()[sMethod](rule, value, callback, vm);
                            },
                            trigger: sTrigger
                        });
                    }
                }

                thisRules[sId] = rules;
            }
        }

        vm.rules = thisRules;
    },
    initViewInfo4NotFlow(vm, respFormValidateInfo) {
        // 初始化表单验证信息（无流程）
        vm.formValidateInfo = respFormValidateInfo;

        let thisRules = {};
        if (vm.formValidateInfo && vm.formValidateInfo.elementLabels) {
            for (let currElementLabel of vm.formValidateInfo.elementLabels) {
                let sId = currElementLabel.id;
                if (!sId) {
                    continue;
                }
                sId = sId.toLowerCase();

                let rules = new Array();
                let oRequired = vm.formValidateInfo.requiredJson[sId];
                let bIsRequired = oRequired ? true : false;
                let sLabel = currElementLabel.label;

                if (bIsRequired) {
                    // cview必填
                    let tipmsg = vm.$t('flow_process.notnulltip');
                    let message = sLabel + "," + tipmsg;
                    rules.push({
                        required: true,
                        validator: (rule, value, callback) => {
                            publicRules.FormValidate.Form().validateRequired(rule, value, callback, message, vm.formTipArray);
                        },
                        trigger: sTrigger
                    });
                }

                let oValidate = vm.formValidateInfo.validateJson[sId];
                if (oValidate) {
                    // cview规则
                    for (let sMethod in oValidate) {
                        if (!sMethod) {
                            continue;
                        }

                        rules.push({
                            elementLabelInfo: currElementLabel,
                            methodInfo: oValidate[sMethod],
                            validator: (rule, value, callback) => {
                                publicRules.FormValidate.Form()[sMethod](rule, value, callback, vm);
                            },
                            trigger: sTrigger
                        });
                    }
                }

                thisRules[sId] = rules;
            }
        }

        vm.rules = thisRules;
    }, checkFormSave4NotFlow(vm, formName = 'record') {
        // 保存校验表单（无流程）
        return validateForm(vm, formName);
    }, initViewInfo4Flow(vm, respFormValidateInfo) {
        // 初始化表单验证信息（流程）
        let thisRules = {};

        if (vm.process && vm.process.notnullitems) {
            // 流程必填域
            let sNotnullitems = vm.process.notnullitems;
            for (let currNotnullitem of sNotnullitems.split(';')) {
                if (!currNotnullitem) {
                    continue;
                }

                let rules = new Array();
                let aNotnullitem = currNotnullitem.split('|');
                let message = '';
                let sInvokeMethod = 'validatePass';
                rules.push({
                    required: true,
                    validator: (rule, value, callback) => {
                        publicRules.FormValidate.Form()[sInvokeMethod](rule, value, callback, message, vm.formTipArray);
                    },
                    trigger: sTrigger
                });

                thisRules[aNotnullitem[0].toLowerCase()] = rules;
            }
        }

        // cview规则
        vm.formValidateInfo = respFormValidateInfo;
        vm.rules = thisRules;
    }, reinitViewInfo4Flow(vm, sNotnullitems) {
        // 重新初始化表单验证信息（流程）
        let thisRules = {};

        vm.process.notnullitems = sNotnullitems;
        if (vm.process && vm.process.notnullitems) {
            // 流程必填域
            let sNotnullitems = vm.process.notnullitems;
            for (let currNotnullitem of sNotnullitems.split(';')) {
                if (!currNotnullitem) {
                    continue;
                }

                let rules = new Array();
                let aNotnullitem = currNotnullitem.split('|');
                let message = '';
                let sInvokeMethod = 'validatePass';
                rules.push({
                    required: true,
                    validator: (rule, value, callback) => {
                        publicRules.FormValidate.Form()[sInvokeMethod](rule, value, callback, message, vm.formTipArray);
                    },
                    trigger: sTrigger
                });

                thisRules[aNotnullitem[0].toLowerCase()] = rules;
            }
        }

        vm.rules = thisRules;
    }, async checkFormSave4Flow(vm, formName = 'record') {
        // 保存校验表单（流程）
        await bindRules4Flow(vm, 'save');
        return validateForm(vm, formName);
    }, async checkFormSubmit4Flow(vm, formName = 'record') {
        // 提交校验表单（流程）
        await bindRules4Flow(vm, 'submit');
        return validateForm(vm, formName);
    },
    
}


// WEBPACK FOOTER //
// ./src/js/formValidate.js